<!--
  We do not use the disabled property for non-editable buttons because then its
  background is semi-transparent so the contents below are visible and they
  don't look quite good.
-->
<template>
  <div style="height:80px">
    <v-divider />
    <h-kitchen-notes @select="$emit('sendnote', $event)">
      <template #activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn
            v-show="showKitchenNote"
            fab
            small
            dark
            ripple
            color="success"
            :loading="loading"
            style="position: absolute; bottom: 20px;"
            :style="{'right': can('charge') ? '184px' : '132px'}"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon v-text="icons.kitchenNote" />
          </v-btn>
        </v-fab-transition>
      </template>
    </h-kitchen-notes>
    <v-fab-transition>
      <v-btn
        v-show="showPrint"
        fab
        small
        dark
        :ripple="canPay"
        :color="canPay ? 'success' : 'grey lighten-2'"
        :depressed="! canPay"
        :loading="loading || printing"
        style="position: absolute; bottom: 20px;"
        :style="{'right': can('charge') ? '132px' : '80px'}"
        @click.stop="print()"
      >
        <v-icon v-text="icons.print" />
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        v-if="can('charge')"
        v-show="showPay"
        fab
        small
        dark
        :ripple="canPay"
        :color="canPay ? 'success' : 'grey lighten-2'"
        :depressed="! canPay"
        :loading="loading"
        :disabled="printing"
        style="position: absolute; bottom: 20px; right: 80px;"
        @click.stop="pay()"
      >
        <v-icon v-text="icons.coins" />
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        v-show="showMain"
        fab
        dark
        :ripple="canEdit"
        :color="canEdit ? 'primary' : 'grey lighten-2'"
        :depressed="! canEdit"
        :loading="loading"
        :disabled="printing"
        style="position: absolute; bottom: 12px; right: 12px;"
        @click.stop="canPay ? edit() : done()"
      >
        <v-icon v-text="canPay ? icons.edit : icons.done" />
      </v-btn>
    </v-fab-transition>
    <h-reason
      v-model="printReasonDialog"
      :title="__('reprintCheck')"
      :label="__('reprintCheckReason')"
      @submit="addPrintReason"
    />
  </div>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import InteractsWithLoading from '@/Mixins/InteractsWithLoading'
  import NeedsPermission from '@/Mixins/NeedsPermission'
  import PrintsTickets from '@/Mixins/PrintsTickets'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HReason from '@/Components/Reason'
  import HKitchenNotes from './KitchenNotes'

  export default {
    mixins: [
      I18n,
      InteractsWithLoading,
      NeedsPermission,
      PrintsTickets,
      UsesIcons,
    ],

    components: {
      HKitchenNotes,
      HReason,
    },

    props: {
      visible: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      showMain: false,
      showPay: false,
      showPrint: false,
      showKitchenNote: false,
      printReasonDialog: false,
    }),

    computed: {
      order () {
        return this.$store.state.orders.current
      },
      canEdit () {
        return !! this.$store.getters['orders/config']('shouldShareOrders')
          || this.order.tenantUser_id == this.$store.state.user.id
          || this.can('openNonSharedTable')
      },
      canPay () {
        return this.canEdit && ! this.order.isPaid
      },
    },

    created () {
      this.autoClosePreviewAfterPrint = true
    },

    mounted () {
      this.showFabs()
    },

    watch: {
      visible (v) {
        v ? this.showFabs() : this.hideFabs()
      },
    },

    methods: {
      hideFabs () {
        this.showMain = false
        this.showPay = false
        this.showPrint = false
        this.showKitchenNote = false
      },
      showFabs () {
        setTimeout(() => {
          this.showMain = true
          setTimeout(() => {
            this.showPay = true
            setTimeout(() => {
              this.showPrint = true
              setTimeout(() => {
                this.showKitchenNote = true
              }, 100)
            }, 100)
          }, 100)
        }, 100)
      },
      edit () {
        if (this.canEdit) {
          this.$emit('edit')
        }
      },
      done () {
        if (this.canEdit) {
          this.$emit('finish')
        }
      },
      pay () {
        if (this.canPay) {
          this.$emit('pay')
        }
      },
      print () {
        if (this.canPay) {
          this.printCheck(this.order)
        }
      },
      addPrintReason (reason) {
        this.signPrintCheck(this.order, reason)
      },
    },
  }
</script>
